import { render, staticRenderFns } from "./EDrawerListarMatriculas.vue?vue&type=template&id=984b4556&scoped=true"
import script from "./EDrawerListarMatriculas.vue?vue&type=script&lang=js"
export * from "./EDrawerListarMatriculas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984b4556",
  null
  
)

export default component.exports